export const random = (min, max) => {
    const n = Math.round(Math.random() * 100) % (max + 1) + min
    return n
}